import { render, staticRenderFns } from "./SpecialtiesComponent.vue?vue&type=template&id=f6c2c37e&scoped=true&"
import script from "./SpecialtiesComponent.vue?vue&type=script&lang=js&"
export * from "./SpecialtiesComponent.vue?vue&type=script&lang=js&"
import style0 from "./SpecialtiesComponent.vue?vue&type=style&index=0&id=f6c2c37e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c2c37e",
  null
  
)

export default component.exports